const geocoderConfig = {
  examples: ["Gartenstrasse 65, Basel", "10 KM 8.5", "N2- BP 0"],
  geocoders: [
    {
      name: "here",
      commonparams: {
        lang: "de",
        apiKey: process.env.GEOCODER_HERE_API_KEY,
      },
    },
    // {
    //     "name": "geofeatureserver",
    //     "dataset": "geob_poisearch",
    //     "filters": [
    //         {
    //             "property": "dataset",
    //             "operator": "eq",
    //             "value": "Parkhaeuser Basel"
    //         }
    //     ],
    //     "queryproperty": "name"
    // }
  ],
};

export default geocoderConfig;
